import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const token = getAuthToken();
  return {
    Authorization: `${token}`,
  };
};

// 🔹 Get My Notifications
export const getMyNotifications = createAsyncThunk(
  "notification/getMyNotifications",
  async ({ page = 1, limit = 20 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}/notification?page=${page}&limit=${limit}`,
        { headers: getHeaders() },
      );
      // console.log(response)
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to load notifications",
      );
    }
  },
);

// 🔹 Get Unread Count
export const getUnreadCount = createAsyncThunk(
  "notification/getUnreadCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/notification/unread/count`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to load unread count");
    }
  },
);

// 🔹 Get Stats
export const getNotificationStats = createAsyncThunk(
  "notification/getNotificationStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/notification/stats`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to load notification stats");
    }
  },
);

// 🔹 Mark As Read
export const markAsRead = createAsyncThunk(
  "notification/markAsRead",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${API_URL}/notification/${id}/read`,
        {},
        { headers: getHeaders() },
      );
      // console.log(response);
      return response.data.data;
    } catch (error) {
      console.error("Error marking notification as read:", error.response);
      handleApiError(error);
      return rejectWithValue("Failed to mark as read");
    }
  },
);

// 🔹 Mark All As Read
export const markAllAsRead = createAsyncThunk(
  "notification/markAllAsRead",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${API_URL}/notification/read/all`,
        {},
        { headers: getHeaders() },
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue("Failed to mark all as read");
    }
  },
);

// 🔹 Delete Notification
export const deleteNotification = createAsyncThunk(
  "notification/deleteNotification",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/notification/${id}`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue("Failed to delete notification");
    }
  },
);

// 🔹 Delete All Notifications
export const deleteAllNotifications = createAsyncThunk(
  "notification/deleteAllNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/notification`, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue("Failed to delete all notifications");
    }
  },
);

// 🔹 Admin Delete Notification
export const adminDeleteNotification = createAsyncThunk(
  "notification/adminDeleteNotification",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${API_URL}/notification/${id}/admin`,
        { headers: getHeaders() },
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue("Admin failed to delete notification");
    }
  },
);
